import { GetServerSidePropsResult, GetStaticPropsResult } from 'next'

type ReturnNextErrorPage = (props: {
  statusCode?: number | string
  avoidNextBehaviour?: boolean
}) => GetServerSidePropsResult<{ [key: string]: unknown }> | GetStaticPropsResult<{ [key: string]: unknown }>

// Workaround to make serverless-next.js work
const returnNextErrorPage: ReturnNextErrorPage = ({ statusCode, avoidNextBehaviour } = {}) => {
  const errorCode = Number(statusCode) || 500

  if (avoidNextBehaviour) {
    return {
      props: {
        errorCode
      }
    }
  }

  if (statusCode) {
    // works with page wrapped into withError hook
    return {
      props: {
        errorCode
      },
      notFound: true
    }
  }

  // works for SSR only
  return {
    notFound: true
  }
}

export default returnNextErrorPage
